import '../css/frontend.css';
import 'aos/dist/aos.css';

import AOS from 'aos';
import { initAlpine } from './alpine';
import { initGlobal } from './components/initGlobal';
import { initSwiper } from './components/initSwiper';
import { initClick } from './components/initClick';
import { initBannerTracking } from './components/bannerTracking';

if (typeof window !== 'undefined') {
  window.AOS = AOS;
}

export const GLOBAL = {
  ui: null,
};

const pageModules = import.meta.glob('./pages/*.js');
const fallbackPage = { init() {}, destroy() {} };
let currentPage = fallbackPage;

function getPageKeyFromBody() {
  const classes = [...document.body.classList];

  // 커스텀 page template (template-*.php)만 타겟
  const templateClass = classes.find((c) =>
    c.startsWith('page-template-template-')
  );

  if (templateClass) {
    // page-template-template-dentistry -> template-dentistry
    return `template-${templateClass.replace('page-template-template-', '').trim()}`;
  }

  const isClass = classes.find((c) => c.startsWith('is-'));
  if (isClass) return isClass.replace('is-', '').trim();

  return 'default';
}

function keyToPath(key) {
  return `./pages/${key}.js`;
}

async function loadPageModule(key) {
  const loader = pageModules[keyToPath(key)];
  if (!loader) return fallbackPage;

  const mod = await loader();
  return {
    init: typeof mod.init === 'function' ? mod.init : fallbackPage.init,
    destroy:
      typeof mod.destroy === 'function' ? mod.destroy : fallbackPage.destroy,
  };
}

// AOS 초기화 함수 추가
function initAOS() {
  AOS.init({
    duration: 600, // 애니메이션 지속 시간
    easing: 'ease-in-out', // 이징
    once: true, // 스크롤 시 한 번만 실행
    offset: 30, // 요소가 보이기 시작할 offset
    delay: 0, // 지연 시간
  });

  // AOS 는 **init 시점의 문서 좌표를 캐시**하고 그 뒤로는 창 크기 변경 때만
  // 다시 잰다(startEvent 가 DOMContentLoaded 라 이미지 로드 전이다). 매장 홈은
  // width/height 없는 이미지가 대부분이라 로드될 때마다 아래 섹션이 밀리고,
  // 아코디언·스와이퍼로도 높이가 바뀐다. 그러면 캐시된 트리거 좌표가 실제와
  // 어긋나 화면 밖에서 애니메이션이 끝나 있거나(효과가 안 보임) 한참 더
  // 내려야 나타난다. 레이아웃이 바뀔 때마다 좌표를 다시 잡는다.
  let refreshTimer = null;
  const refreshAos = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => AOS.refresh(), 100);
  };

  window.addEventListener('load', refreshAos);
  document.fonts?.ready?.then(refreshAos);

  // 문서 높이 변화 전반(지연 로드 이미지·웹폰트·아코디언·스와이퍼)을 한 곳에서
  // 받는다. AOS 애니메이션은 opacity/transform 만 바꿔 레이아웃 크기에 영향이
  // 없으므로 되먹임 루프는 생기지 않는다.
  if ('ResizeObserver' in window) {
    new ResizeObserver(refreshAos).observe(document.body);
  }
}

async function boot() {
  initAlpine();
  initGlobal();
  initSwiper();
  initClick();
  initBannerTracking();

  if (document.body.classList.contains('dc-section-home')) {
    initAOS();
  }

  const key = getPageKeyFromBody();
  currentPage = await loadPageModule(key);
  currentPage.init?.({ GLOBAL, key });
}

document.addEventListener('DOMContentLoaded', () => {
  boot();
});
